<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Get Paid More and Promoted Faster</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="titlepage" id="d14e34">
<h1 id="d7e122"><br/> GET PAID  <br/> MORE  <br/><span class="small">AND</span><br/>  PROMOTED  <br/> FASTER </h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HalfTitle.vue?33f5d9f2